module.exports = __webpack_public_path__ + "static/media/function_hk.96c36c45.png";